import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M7.746 5.92a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 0 1h-3.5a.5.5 0 0 1-.5-.5ZM6.607 4.566a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.707 0l-.5-.5a.5.5 0 0 1 .707-.708l.146.147L5.9 4.566a.5.5 0 0 1 .707 0ZM7.746 10.587a.5.5 0 0 1 .5-.5h3.5a.5.5 0 1 1 0 1h-3.5a.5.5 0 0 1-.5-.5ZM6.607 9.233a.5.5 0 0 1 0 .707l-1.5 1.5a.5.5 0 0 1-.707 0l-.5-.5a.5.5 0 1 1 .707-.707l.146.147L5.9 9.233a.5.5 0 0 1 .707 0Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M2.063 2.063c.89-.89 2.22-1.23 3.937-1.23h4c1.716 0 3.047.34 3.937 1.23.89.89 1.23 2.221 1.23 3.937v4c0 1.716-.34 3.047-1.23 3.937-.89.89-2.221 1.23-3.937 1.23H6c-1.716 0-3.047-.34-3.937-1.23-.89-.89-1.23-2.221-1.23-3.937V6c0-1.716.34-3.047 1.23-3.937Zm.707.707c-.61.61-.937 1.613-.937 3.23v4c0 1.617.327 2.62.937 3.23.61.61 1.612.937 3.23.937h4c1.617 0 2.62-.327 3.23-.937.61-.61.936-1.613.936-3.23V6c0-1.617-.326-2.62-.936-3.23-.61-.61-1.613-.937-3.23-.937H6c-1.618 0-2.62.327-3.23.937Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }